import { Reveal } from "@/components/Reveal";
import InstagramEmbed from "@/components/InstagramEmbed";

// Feedbacks reais — posts de clientes no Instagram
const FEEDBACKS = ["DbMVmbvRT9l", "DbtkvqORB8X", "DX7xI4ERiVd", "DUrEMrzkZ3H"];

const Testimonials = () => (
    <section data-testid="testimonials-section" className="bg-white text-[#0A0A0A] px-6 md:px-12 py-28 md:py-40 border-t border-black/10">
        <div className="max-w-7xl mx-auto">
            <Reveal>
                <p className="text-[10px] tracking-[0.45em] uppercase text-[#6A2022] mb-8" data-testid="testimonials-label">
                    Depoimentos
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.95] tracking-tight" data-testid="testimonials-headline">
                    Quem vive,{" "}
                    <span className="font-editorial italic font-light normal-case text-[#6A2022]">conta.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="mt-6 text-[11px] tracking-[0.25em] uppercase text-[#0A0A0A]/40" data-testid="testimonials-note">
                    Avaliações reais, publicadas por quem viveu a experiência
                </p>
            </Reveal>

            <div className="mt-16 md:mt-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                {FEEDBACKS.map((id, i) => (
                    <Reveal key={id} delay={i * 0.1}>
                        <div className="border border-black/10 overflow-hidden h-[540px]" data-testid={`testimonial-${i + 1}`}>
                            <InstagramEmbed id={id} title={`Feedback de cliente ${i + 1}`} />
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Testimonials;
